
/*
 *   File : preview.js
 *   Author URI : https://evoqins.com
 *   Description : File preview *   Integrations : null
 *   Version : v1.1
 */
/*import packages*/
import { Fragment, React, useEffect, useState } from "react";

/*import components*/
import { Icon } from "../Icon";
import { Modal } from "bootstrap";
import { FileViewer } from "../Modal";


const FilePreview = (props) => {
    const [showRedDeleteIcon, setShowRedDeleteIcon] = useState(false);
    const [openFileViewer, setOpenFileViewer] = useState(false);
    const [fileData, setFileData] = useState({ url: "", type: 1 });

    useEffect(() => {
        if (openFileViewer === true) {
            const modal = new Modal(document.getElementById("file-viewer"));
            modal.show();
        }
    }, [openFileViewer]);


    const _handleDelete = (status) => {
        setShowRedDeleteIcon(status);
    };


    const _handlePreviewImage = (url, type) => {
        setFileData({ url, type });
        setOpenFileViewer(true);
    }

    function _callbackFileViewerModalClose() {
        setOpenFileViewer(false);
        setFileData({ url: "", type: 1 });
    }

    return (
        <Fragment>

            {props.type === 2 ?
                <div className="position-relative">
                    <div className={`border-radius-8px border-all-dashed bg-pale-baby-blue px-3 py-2 d-flex justify-content-between align-items-center cursor-pointer ${props.className} ${props.error ? 'border-red' : 'border-primary-color'}`}
                    >
                        <div className="d-flex align-items-center gap-2">
                            <img draggable={false} src={props.icon} alt="File upload" className="border-radius-4px"
                                width={24}
                                height={24} />
                            <div >
                                <p style={{ maxWidth: '130px' }} className="color-jett-black e-poppins-regular text-truncate e-font-14  mb-0 overflow-hidden mt-0">{props.fileName}</p>
                                <p className="color-outer-space  e-poppins-regular e-font-8 mb-0 overflow-hidden my-0">{`File size:${props.fileSize}`}</p>
                            </div>
                        </div>

                        <div className="gap-2 d-flex align-items-center ">

                            <span>
                                <Icon icon={"eye"} alt="Preview"
                                    size={24}
                                    className=" cursor-pointer"
                                    onClick={() => _handlePreviewImage(props.icon, 2)} />
                            </span>

                            <Icon icon={showRedDeleteIcon ? "delete-red" : "delete"} alt="delete"
                                size={24}
                                className=" cursor-pointer"
                                onClick={() => {
                                    props.clearFile()
                                }}
                                onMouseEnter={() => {
                                    _handleDelete(true)
                                }}
                                onMouseLeave={() => {
                                    _handleDelete(false)
                                }} />

                        </div>

                    </div>

                </div>
                :
                <div className="d-flex align-items-center mt-1">
                    <p className="border-radius-8px d-flex justify-content-between bg-pale-baby-blue p-2 color-jett-black e-font-10 e-poppins-regular line-height-24px mb-0 w-90">
                        <span className="truncate-first-line">{props.fileName}</span>
                        {
                            !props.hidePreviewIcon &&
                            <img draggable={false} src={require("../../Assets/Images/Notifications/preview.svg").default}
                                alt="preview"
                                className="ms-2" />
                        }

                    </p>
                    {
                        props.showBinIcon !== false &&
                        <Icon icon={showRedDeleteIcon ? "delete-red" : "delete"} alt="delete"
                            size={24}
                            className="margin-6px-left cursor-pointer"
                            onClick={() => {
                                props.clearFile()
                            }}
                            onMouseEnter={() => {
                                _handleDelete(true)
                            }}
                            onMouseLeave={() => {
                                _handleDelete(false)
                            }} />
                    }
                </div>
            }

            {
                openFileViewer === true &&
                <FileViewer
                    data={fileData}
                    close={_callbackFileViewerModalClose} />
            }
        </Fragment>
    )
}

FilePreview.defaultProps = {
    file: "",
    clearFile: () => { }
}

export default FilePreview;